import { getVideoSource } from "./getVideoSource";

export function getYoutubeVideoIdFromUrl(url) {
  let v;

  // the easiest is if the url has the v= param
  const theUrl = new URL(url);
  v = theUrl.searchParams.get("v");

  if (v) return v;

  // matches the pattern of /v/VIDEO_ID
  const matchesPattern1 = url.match(/\/v\//);
  if (matchesPattern1) {
    const splitUrl = theUrl.pathname.split("/v/");
    v = splitUrl[1];

    return v;
  }

  // matches the pattern of youtu.be/VIDEO_ID and youtu.be/VIDEO_ID&feature=channel
  const matchesPattern2 = url.match(/youtu.be/);
  if (matchesPattern2) {
    const splitUrl = theUrl.pathname.split("/");
    const splitV = splitUrl[1];
    v = splitV.split("&")[0];
    return v;
  }

  // matches embed url pattern
  const matchesPattern3 = url.match(/\/embed\//);
  if (matchesPattern3) {
    const splitUrl = theUrl.pathname.split("/embed/");
    v = splitUrl[1];
    return v;
  }

  // matches the pattern of /e/VIDEO_ID
  const matchesPattern4 = url.match(/\/e\//);
  if (matchesPattern4) {
    const splitUrl = theUrl.pathname.split("/e/");
    v = splitUrl[1];
    return v;
  }

  // matches http://www.youtube.com/attribution_link?a=JdfC0C9V6ZI&u=%2Fwatch%3Fv%3DEhxJLojIE_o%26feature%3Dshare
  // also matches http://www.youtube.com/attribution_link?a=8g8kPrPIi-ecwIsS&u=/watch%3Fv%3DyZv2daTWRZU%26feature%3Dem-uploademail
  const matchesPattern5 = url.match(/v%3D/);
  if (matchesPattern5) {
    const u = theUrl.searchParams.get("u");
    const paramString = u.split("?")[1];
    const params = new URLSearchParams(paramString);
    v = params.get("v");
    return v;
  }

  const matchesPattern6 = url.match(/\/shorts\//);
  if (matchesPattern6) {
    const splitUrl = theUrl.pathname.split("/shorts/");
    v = splitUrl[1];
    return v;
  }

  return null;
}

export function getVimeoVideoIdFromUrl(url) {
  let regExp =
    /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
  let match = url.match(regExp);
  if (match && match[5]) {
    return match[5];
  }
  regExp = /vimeo\.com\/video\/([0-9]+)/;
  match = url.match(regExp);
  if (match && match[1]) {
    return match[1];
  }
  return false;
}

export function getVimeoHKeyFromUrl(url) {
  const urlParamString = url.split("?")[1] ?? "";
  const urlParams = urlParamString.split("&");
  for (const paramString of urlParams) {
    const splitParam = paramString.split("=");
    if (splitParam[0] && splitParam[1] && splitParam[0] === "h") {
      return splitParam[1];
    }
  }
  return null;
}

function generateYoutubeEmbedUrl(url) {
  const videoId = getYoutubeVideoIdFromUrl(url);
  return `https://www.youtube.com/embed/${videoId}`;
}

function generateVimeoEmbedUrl(url) {
  const videoId = getVimeoVideoIdFromUrl(url);
  const vimeoHKey = getVimeoHKeyFromUrl(url);
  let result = `https://player.vimeo.com/video/${videoId}`;
  if (vimeoHKey) {
    result += `?h=${vimeoHKey}`;
  }
  return result;
}

export async function generateEmbedUrl(url) {
  if (!url) return null;

  const videoSource = await getVideoSource(url);
  if (videoSource === "youtube") return generateYoutubeEmbedUrl(url);
  if (videoSource === "vimeo") return generateVimeoEmbedUrl(url);
  return null;
}
